import { useJobInfo } from "@/api/services/main/job";
import { LoadingPage } from "@/components/elements/Loading/Loading";
import { JobForm } from "@/features/job/components/JobForm";
import { DEFAULT_ONBOARDING_SUPPORTS, DEFAULT_SELF_EXPENSES } from "@/features/job/constants/defaults";
import { convertResToFormData, createJobSalarySummaryForm, initJobWorkingTimeForm } from "@/features/job/utils/convertJobFormData";
import { useValidateId } from "@/hooks/useValidateId";
import { AppRoutes } from "@/routes/config";
import { YES_NO_PENDING_STATUS } from "@/types/enum";

export const JobEditPage = () => {
  const queryResult = useJobInfo();
  const { data, isLoading } = queryResult;
  useValidateId("jobId", AppRoutes.jobList, queryResult);

  if (!data || isLoading) return <LoadingPage />;

  const defaultValues = convertResToFormData(data.data);
  const initDefaultValues = {
    ...defaultValues,
    jobWorkingTimes: defaultValues?.jobWorkingTimes ?? [initJobWorkingTimeForm],
    jobSalarySummaries: defaultValues?.jobSalarySummaries ?? [createJobSalarySummaryForm()],
    bonus: defaultValues?.bonus ?? YES_NO_PENDING_STATUS.PENDING,
    salaryRaise : defaultValues?.salaryRaise ?? YES_NO_PENDING_STATUS.PENDING,
    selfExpense: defaultValues?.selfExpense ?? DEFAULT_SELF_EXPENSES,
    onboardingSupport: defaultValues?.onboardingSupport ?? DEFAULT_ONBOARDING_SUPPORTS,
  };

  return <JobForm defaultValues={initDefaultValues} />;
};
